// components/layout/Footer.tsx
import Link from "next/link";
import {FOOTER_LINKS} from "@/shared/pages/menus";

export default function Footer() {
	const currentYear = new Date().getFullYear();
	return (
		<footer>
			<div className="section-footer">
				<div className="container-fluid bg-primary-soft">
					<div className="container">
						<div className="row">
							<div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 py-4 border-top border-white border-opacity-10">
								<p className="text-900 opacity-50 mb-0 fs-7">
									Copyright © {currentYear} The Sixth Hammer. All Rights Reserved
								</p>

								<nav aria-label="Legal">
									<ul className="d-flex list-unstyled mb-0">
										{FOOTER_LINKS.map((item) => (
											<li key={item.href} className="me-3">
												<Link href={item.href} className="text-900">
													{item.label}
												</Link>
											</li>
										))}
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
